/**
 * Where the SPA is mounted: '' at the root of a host (run.app, staging, local
 * dev) or '/admin' behind https://billing.spoonity.com/admin. The BFF writes it
 * into index.html as `<base href="<prefix>/" />` per request (server/src/prefix.ts,
 * which only accepts allow-listed prefixes); this reads it back for the router
 * basename (main.tsx) and the BFF calls (api/client.ts, auth, feedback, updates).
 *
 * Defense in depth: anything that is not a plain `/segment/.../` path reads as
 * '' (the root), so a stray or injected <base> can never point API calls at
 * another origin.
 */

const BASE_HREF = /^(?:\/[A-Za-z0-9][A-Za-z0-9_-]{0,31}){0,4}\/$/;

export function readBasePath(doc: Document | undefined = typeof document === 'undefined' ? undefined : document): string {
  const href = doc?.querySelector('base')?.getAttribute('href') ?? '';
  return BASE_HREF.test(href) ? href.slice(0, -1) : '';
}

/** `path` (starting with `/`) under the mount point, e.g. '/api/meta' -> '/admin/api/meta'. */
export function withBase(path: string, base: string = readBasePath()): string {
  return `${base}${path}`;
}
